import jwtAuthAxios from "../auth/jwtAuth";

// «Conexión de equipos»: avisos cuando un sensor deja de enviar datos o un local pierde la conexión.
const connectivityAlertServices = {};

connectivityAlertServices.getConnectivityAlert = async (id) => {
    const { data } = await jwtAuthAxios.get(`/automations/connectivity_alerts/${id}`);
    return data;
};

connectivityAlertServices.getEditOptions = async () => {
    const { data } = await jwtAuthAxios.get("/automations/connectivity_alerts/edit_options");
    return data;
};

connectivityAlertServices.createConnectivityAlert = async (alert) => {
    const { data } = await jwtAuthAxios.post("/automations/connectivity_alerts", { connectivity_alert: alert });
    return data;
};

connectivityAlertServices.updateConnectivityAlert = async (id, alert) => {
    const { data } = await jwtAuthAxios.put(`/automations/connectivity_alerts/${id}`, { connectivity_alert: alert });
    return data;
};

connectivityAlertServices.deleteConnectivityAlert = async (id) => {
    const { data } = await jwtAuthAxios.delete(`/automations/connectivity_alerts/${id}`);
    return data;
};

export default connectivityAlertServices;
